import React from 'react';
import ReactDOM from 'react-dom';
import DeliveryOptions from '../customer_pages/_grouped-category/delivery-options';
import Pickup from '../customer_pages/_grouped-category/pickup';
import Shipping from '../customer_pages/_grouped-category/shipping';
import MobileFullScreen from 'Utils/mobile-full-screen';
import DeliveryCalculator from 'Utils/_delivery-options/calculator';
import DeliveryOptionsList from 'Utils/_delivery-options/delivery-options-list';
import createContextProvider from 'Utils/create-context-provider';
import FavouritableWrapper from 'Utils/favouritable-wrapper';
import ProductFlags from 'Utils/product-flags';
import setCanonicalUrl from 'Utils/tools/canonical-url';


// Add Imported Modules to the windows so that they become available for the static page!
window.DeliveryOptions = DeliveryOptions;
window.DeliveryCalculator = DeliveryCalculator;
window.DeliveryOptionsList = DeliveryOptionsList;
window.Pickup = Pickup;
window.Shipping = Shipping;
window.MobileFullScreen = MobileFullScreen;
window.createContextProvider = createContextProvider;
window.FavouritableWrapper = FavouritableWrapper;
window.ProductFlags = ProductFlags;
window.setCanonicalUrl = setCanonicalUrl;

// This is ESSENTIAL: otherwise there'll be console errors caused by:
// having two React/ReactDOM libraries: one from the webpack bundle (although we're
// specifying it as external) and one loaded from application.html.slim
window.React = React;
window.ReactDOM = ReactDOM;
